import { defineMessages } from 'react-intl';

export const messages: {
	deleteTemplateModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalCancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalConfirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalSuccessFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTemplateModalErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deleteTemplateModalTitle: {
		id: 'snippets.deleteTemplateModalTitle',
		defaultMessage: 'Delete this template?',
		description: 'Title for the delete template confirmation modal',
	},
	deleteTemplateModalBody: {
		id: 'snippets.deleteTemplateModalBody',
		defaultMessage: 'It will no longer appear in search or My templates',
		description: 'Body text for the delete template confirmation modal',
	},
	deleteTemplateModalCancelButton: {
		id: 'snippets.deleteTemplateModalCancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button for the delete template modal',
	},
	deleteTemplateModalConfirmButton: {
		id: 'snippets.deleteTemplateModalConfirmButton',
		defaultMessage: 'Confirm',
		description: 'Confirm button for the delete template modal',
	},
	deleteTemplateModalSuccessFlagTitle: {
		id: 'snippets.deleteTemplateModalSuccessFlagTitle',
		// oxlint-disable-next-line eslint-core/no-restricted-syntax
		defaultMessage: 'Template "{snippetName}" deleted',
		description: 'Title for the success flag shown when template deletion succeeds',
	},
	deleteTemplateModalSuccessFlagDescription: {
		id: 'snippets.deleteTemplateModalSuccessFlagDescription',
		defaultMessage: 'The template has been removed',
		description: 'Description for the success flag shown when template deletion succeeds',
	},
	deleteTemplateModalErrorFlagTitle: {
		id: 'snippets.deleteTemplateModalErrorFlagTitle',
		defaultMessage: 'Could not delete template',
		description: 'Title for the error flag shown when template deletion fails',
	},
	deleteTemplateModalErrorFlagDescription: {
		id: 'snippets.deleteTemplateModalErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Description for the error flag shown when template deletion fails',
	},
});
